var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user)?_c('section',{staticClass:"user-edit"},[_c('h3',{staticClass:"title is-3"},[_vm._v("Benutzer "+_vm._s(_vm.user.username)+" editieren")]),_c('UserForm',{attrs:{"user":_vm.user},on:{"update:user":function($event){_vm.user=$event},"submit":_vm.dispatchUpdateUser}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }